export class OcorrenciaPadraoModel {
  constructor({ id, nome, ocorrencia, acaoCorretiva, setores = [] }) {
    this.id = id;
    this.nome = nome;
    this.ocorrencia = ocorrencia;
    this.acaoCorretiva = acaoCorretiva;
    this.setores = setores;
  }
}
